"use client";
import * as React from "react";
const SvgTrashRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 12 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M.86 14.22c0 .98.77 1.78 1.71 1.78h6.86c.94 0 1.71-.8 1.71-1.78V5.33c0-.97-.77-1.77-1.71-1.77H2.57c-.94 0-1.71.8-1.71 1.77zM11.14.9H9L8.4.26A1 1 0 0 0 7.8 0H4.2a1 1 0 0 0-.6.26L3 .89H.86c-.47 0-.86.4-.86.89s.39.89.86.89h10.28c.47 0 .86-.4.86-.9a.9.9 0 0 0-.86-.88Z" }));
export {
  SvgTrashRound as default
};
